import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'angular-2-local-storage';

@Injectable({
  providedIn: 'root',
})
export class HttpRequestPlacetopayService {
  pathService = environment.PLACETOPAY_PAYMENT_URL;
  private readonly TOKEN_LOCAL_STORAGE_KEY = 'gal-ut-pr';

  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService
  ) {}

  /**
   * Obtiene el header de autenticación Basic con el token del usuario.
   * Usa el mismo formato que GalavailRestAuthService.getBasicAuthHeader()
   */
  private getAuthHeaders(): HttpHeaders {
    const token = this.localStorageService.get<string>(this.TOKEN_LOCAL_STORAGE_KEY);
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    if (token) {
      const encodedToken = btoa('token:' + token);
      headers = headers.set('Authorization', 'Basic ' + encodedToken);
    }

    return headers;
  }

  /**
   * Realiza una petición POST con autenticación.
   * @param requestServiceName Nombre del endpoint (ej: 'statusOnHoldPlaceToPay')
   * @param body Cuerpo de la petición
   * @returns Observable con la respuesta
   */
  requestPost(requestServiceName: string, body: any): Observable<any> {
    const url = `${this.pathService}${requestServiceName}`;
    const headers = this.getAuthHeaders();
    return this.http.post<any>(url, body, { headers });
  }
}
